"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx15 = _interopRequireDefault(require("clsx"));
var _context11 = _interopRequireDefault(require("../Theme/context"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _context12 = _interopRequireDefault(require("./context"));
var _Popover = _interopRequireDefault(require("../Modal/Popover"));
var _excluded = ["modal"],
  _excluded2 = ["classNames", "classes", "variant", "paperVariant", "disabled", "active", "label", "labelEnableWrap", "secondaryText", "secondaryTextEnableWrap", "children", "className", "defaultClassName", "disableElevation", "startIcon", "endIcon", "EndIconContainerComponent", "startIconSeparator", "StartIconContainerComponent", "endIconSeparator", "icon", "IconContainerComponent", "onlyIcon", "circle", "onClick", "onClickBefore", "size", "enablePaperSizes", "ButtonBaseContentComponent", "TypographyComponent", "TypographyProps", "LabelComponent", "fullWidth", "effect", "disableForceUpdateForIcons", "contextModifications", "TipPopoverComponent", "TipPopoverProps", "TipPaperComponent", "TipPaperProps", "stopPropagation", "draggable"],
  _excluded3 = ["children", "active", "disabled", "size", "variant", "color"],
  _excluded4 = ["children", "active", "disabled", "size", "variant", "color"],
  _excluded5 = ["children", "active", "disabled", "size", "variant", "color"],
  _excluded6 = ["Component", "href", "tip", "ariaLabel"];
var defaultStyle = require("./../empty_css.js")["default"];
function Tip(props) {
  var _tipPopperOptions$mod, _tipPopperOptions$mod2;
  var _props$TipPopoverComp = props.TipPopoverComponent,
    TipPopoverComponent = _props$TipPopoverComp === void 0 ? _Popover["default"] : _props$TipPopoverComp,
    _props$TipPopoverProp = props.TipPopoverProps,
    TipPopoverProps = _props$TipPopoverProp === void 0 ? {} : _props$TipPopoverProp,
    _props$TipPaperCompon = props.TipPaperComponent,
    TipPaperComponent = _props$TipPaperCompon === void 0 ? _Paper["default"] : _props$TipPaperCompon,
    _props$TipPaperProps = props.TipPaperProps,
    TipPaperProps = _props$TipPaperProps === void 0 ? {} : _props$TipPaperProps,
    tip = props.tip,
    _props$tipModal = props.tipModal,
    tipModal = _props$tipModal === void 0 ? {} : _props$tipModal,
    buttonContext = props.buttonContext,
    effect = props.effect,
    classNames = props.classNames;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setAnchorEl: setAnchorEl
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setAnchorEl: function () {
              var _setAnchorEl = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      return _context.abrupt("return", null);
                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              function setAnchorEl() {
                return _setAnchorEl.apply(this, arguments);
              }
              return setAnchorEl;
            }()
          }
        });
      }
    };
  });
  var tipPopperOptions = TipPopoverProps.popperOptions || {};
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, tip && anchorEl ? /*#__PURE__*/_react["default"].createElement(TipPopoverComponent, Object.assign({
    getAnchorElement: function getAnchorElement() {
      return anchorEl;
    }
  }, TipPopoverProps, {
    effect: function effect(_ref) {
      var modal = _ref.modal,
        rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
      tipModal.actions = modal.actions;
      if (TipPopoverProps.effect) {
        TipPopoverProps.effect((0, _objectSpread2["default"])({
          modal: modal
        }, rest));
      }
    },
    onOpen: /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!TipPopoverProps.onOpen) {
              _context2.next = 3;
              break;
            }
            _context2.next = 3;
            return TipPopoverProps.onOpen();
          case 3:
            if (!buttonContext.tipOnOpen) {
              _context2.next = 6;
              break;
            }
            _context2.next = 6;
            return buttonContext.tipOnOpen({
              modal: tipModal
            });
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })),
    popperOptions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
      placement: 'bottom'
    }, tipPopperOptions), {}, {
      modifiers: [].concat((0, _toConsumableArray2["default"])((_tipPopperOptions$mod = tipPopperOptions.modifiers) !== null && _tipPopperOptions$mod !== void 0 && _tipPopperOptions$mod.find(function (m) {
        return m.name === 'offset';
      }) ? [tipPopperOptions.modifiers.find(function (m) {
        return m.name === 'offset';
      })] : [{
        name: 'offset',
        options: {
          offset: [0, 8]
        }
      }]), (0, _toConsumableArray2["default"])((_tipPopperOptions$mod2 = tipPopperOptions.modifiers) !== null && _tipPopperOptions$mod2 !== void 0 && _tipPopperOptions$mod2.find(function (m) {
        return m.name === 'flip';
      }) ? [tipPopperOptions.modifiers.find(function (m) {
        return m.name === 'flip';
      })] : [{
        name: 'flip',
        options: {
          fallbackPlacements: ['top', 'right', 'left']
        }
      }]), (0, _toConsumableArray2["default"])(tipPopperOptions.modifiers ? tipPopperOptions.modifiers.filter(function (m) {
        return m.name !== 'offset' && m.name !== 'flip';
      }) : []))
    }),
    disableScroll: false,
    BackdropComponent: function BackdropComponent() {
      return null;
    }
  }), /*#__PURE__*/_react["default"].createElement(TipPaperComponent, Object.assign({
    size: 'small',
    variant: 'contained',
    arrow: true,
    onClick: (/*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(e) {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              e.preventDefault();
              e.stopPropagation();
              _context3.next = 4;
              return tipModal.actions.setOpen(false);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }())
  }, TipPaperProps, {
    className: (0, _clsx15["default"])(classNames.tipPaper, TipPaperProps.className)
  }), tip)) : null);
}
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, _ref10) {
  var _useContext = (0, _react.useContext)(_context11["default"]),
    componentsStyle = _useContext.componentsStyle,
    useStyle = _useContext.useStyle;
  var defaultButtonContext = (0, _react.useContext)(_context12["default"]);
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? componentsStyle || defaultStyle : _props$classNames,
    _props$classes = props.classes,
    classes = _props$classes === void 0 ? {} : _props$classes,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'contained' : _props$variant,
    paperVariant = props.paperVariant,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$active = props.active,
    active = _props$active === void 0 ? false : _props$active,
    _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    _props$labelEnableWra = props.labelEnableWrap,
    labelEnableWrap = _props$labelEnableWra === void 0 ? false : _props$labelEnableWra,
    _props$secondaryText = props.secondaryText,
    secondaryText = _props$secondaryText === void 0 ? '' : _props$secondaryText,
    _props$secondaryTextE = props.secondaryTextEnableWrap,
    secondaryTextEnableWrap = _props$secondaryTextE === void 0 ? false : _props$secondaryTextE,
    _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    className = props.className,
    defaultClassName = props.defaultClassName,
    _props$disableElevati = props.disableElevation,
    disableElevation = _props$disableElevati === void 0 ? variant === 'text' : _props$disableElevati,
    _props$startIcon = props.startIcon,
    startIcon = _props$startIcon === void 0 ? null : _props$startIcon,
    _props$endIcon = props.endIcon,
    endIcon = _props$endIcon === void 0 ? null : _props$endIcon,
    _props$EndIconContain = props.EndIconContainerComponent,
    EndIconContainerComponent = _props$EndIconContain === void 0 ? function (_ref4) {
      var children = _ref4.children,
        active = _ref4.active,
        disabled = _ref4.disabled,
        size = _ref4.size,
        variant = _ref4.variant,
        color = _ref4.color,
        props = (0, _objectWithoutProperties2["default"])(_ref4, _excluded3);
      return /*#__PURE__*/_react["default"].createElement("div", props, children);
    } : _props$EndIconContain,
    _props$startIconSepar = props.startIconSeparator,
    startIconSeparator = _props$startIconSepar === void 0 ? false : _props$startIconSepar,
    _props$StartIconConta = props.StartIconContainerComponent,
    StartIconContainerComponent = _props$StartIconConta === void 0 ? function (_ref5) {
      var children = _ref5.children,
        active = _ref5.active,
        disabled = _ref5.disabled,
        size = _ref5.size,
        variant = _ref5.variant,
        color = _ref5.color,
        props = (0, _objectWithoutProperties2["default"])(_ref5, _excluded4);
      return /*#__PURE__*/_react["default"].createElement("div", props, children);
    } : _props$StartIconConta,
    _props$endIconSeparat = props.endIconSeparator,
    endIconSeparator = _props$endIconSeparat === void 0 ? false : _props$endIconSeparat,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? null : _props$icon,
    _props$IconContainerC = props.IconContainerComponent,
    IconContainerComponent = _props$IconContainerC === void 0 ? function (_ref6) {
      var children = _ref6.children,
        active = _ref6.active,
        disabled = _ref6.disabled,
        size = _ref6.size,
        variant = _ref6.variant,
        color = _ref6.color,
        props = (0, _objectWithoutProperties2["default"])(_ref6, _excluded5);
      return /*#__PURE__*/_react["default"].createElement("div", props, children);
    } : _props$IconContainerC,
    onlyIcon = props.onlyIcon,
    _props$circle = props.circle,
    circle = _props$circle === void 0 ? false : _props$circle,
    _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? null : _props$onClick,
    _props$onClickBefore = props.onClickBefore,
    onClickBefore = _props$onClickBefore === void 0 ? null : _props$onClickBefore,
    _props$size = props.size,
    size = _props$size === void 0 ? variant === 'inline' ? 'none' : 'default' : _props$size,
    enablePaperSizes = props.enablePaperSizes,
    ButtonBaseContentComponent = props.ButtonBaseContentComponent,
    _props$TypographyComp = props.TypographyComponent,
    TypographyComponent = _props$TypographyComp === void 0 ? _Typography["default"] : _props$TypographyComp,
    _props$TypographyProp = props.TypographyProps,
    TypographyProps = _props$TypographyProp === void 0 ? {} : _props$TypographyProp,
    _props$LabelComponent = props.LabelComponent,
    LabelComponent = _props$LabelComponent === void 0 ? variant === 'inline' ? 'span' : 'div' : _props$LabelComponent,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
    effect = props.effect,
    disableForceUpdateForIcons = props.disableForceUpdateForIcons,
    contextModifications = props.contextModifications,
    _props$TipPopoverComp2 = props.TipPopoverComponent,
    TipPopoverComponent = _props$TipPopoverComp2 === void 0 ? _Popover["default"] : _props$TipPopoverComp2,
    _props$TipPopoverProp2 = props.TipPopoverProps,
    TipPopoverProps = _props$TipPopoverProp2 === void 0 ? {} : _props$TipPopoverProp2,
    _props$TipPaperCompon2 = props.TipPaperComponent,
    TipPaperComponent = _props$TipPaperCompon2 === void 0 ? _Paper["default"] : _props$TipPaperCompon2,
    _props$TipPaperProps2 = props.TipPaperProps,
    TipPaperProps = _props$TipPaperProps2 === void 0 ? {} : _props$TipPaperProps2,
    stopPropagation = props.stopPropagation,
    _props$draggable = props.draggable,
    draggable = _props$draggable === void 0 ? false : _props$draggable,
    rest3 = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  var Component = rest3.Component,
    _rest3$href = rest3.href,
    href = _rest3$href === void 0 ? '' : _rest3$href,
    _rest3$tip = rest3.tip,
    tip = _rest3$tip === void 0 ? '' : _rest3$tip,
    ariaLabel = rest3.ariaLabel,
    rest = (0, _objectWithoutProperties2["default"])(rest3, _excluded6);
  var buttonContext = contextModifications ? contextModifications(defaultButtonContext) : defaultButtonContext;
  href = buttonContext.href ? buttonContext.href((0, _objectSpread2["default"])({
    href: href
  }, rest)) : href;
  if (typeof Component === 'undefined') {
    Component = href ? 'a' : 'button';
  }
  if (classNames !== componentsStyle) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var _useState3 = (0, _react.useState)(active),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    _active = _useState4[0],
    _setActive = _useState4[1];
  var _useState5 = (0, _react.useState)(disabled),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    _disabled = _useState6[0],
    _setDisabled = _useState6[1];
  function setActive(_x2) {
    return _setActive2.apply(this, arguments);
  }
  function _setActive2() {
    _setActive2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee9(value) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            if (!(value !== _active)) {
              _context9.next = 3;
              break;
            }
            _context9.next = 3;
            return _setActive(value);
          case 3:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return _setActive2.apply(this, arguments);
  }
  function setDisabled(_x3) {
    return _setDisabled2.apply(this, arguments);
  }
  function _setDisabled2() {
    _setDisabled2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee10(value) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            if (!(value !== _disabled)) {
              _context10.next = 3;
              break;
            }
            _context10.next = 3;
            return _setDisabled(value);
          case 3:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return _setDisabled2.apply(this, arguments);
  }
  var _onlyIcon = onlyIcon || icon && !(children || label) && !startIcon && !endIcon;
  if (_onlyIcon && (label || children) && !_disabled) {
    tip = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label || children);
  }
  if (typeof ariaLabel === 'undefined') {
    ariaLabel = [typeof children === 'string' ? children : typeof label === 'string' ? label : '', typeof secondaryText === 'string' ? secondaryText : ''].filter(function (t) {
      return t;
    }).join(' ');
    if (!ariaLabel && typeof tip === 'string') {
      ariaLabel = tip;
    }
  }
  var onClickResolver = /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(e) {
      var _tipModal$actions;
      var contains;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            (_tipModal$actions = tipModal.actions) === null || _tipModal$actions === void 0 ? void 0 : _tipModal$actions.setOpen(false);
            contains = true;
            try {
              if (!buttonRef.current.contains(e.target)) {
                contains = false;
              }
            } catch (e) {}
            if (!contains) {
              _context4.next = 15;
              break;
            }
            if (!onClickBefore) {
              _context4.next = 7;
              break;
            }
            _context4.next = 7;
            return onClickBefore(e);
          case 7:
            if (!onClick) {
              _context4.next = 12;
              break;
            }
            _context4.next = 10;
            return onClick(e, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
              href: href,
              disabled: disabled
            }, rest), {}, {
              buttonContext: buttonContext
            }));
          case 10:
            _context4.next = 15;
            break;
          case 12:
            if (!buttonContext.onClick) {
              _context4.next = 15;
              break;
            }
            _context4.next = 15;
            return buttonContext.onClick(e, (0, _objectSpread2["default"])({
              href: href,
              disabled: disabled
            }, rest));
          case 15:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function onClickResolver(_x4) {
      return _ref7.apply(this, arguments);
    };
  }();
  var container = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        mounted: true,
        actions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, container.actions ? container.actions : {}), {}, {
          setActive: setActive,
          setDisabled: setDisabled
        })
      });
    }
    return function () {
      if (effect) {
        effect({
          "false": true,
          actions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, container.actions ? container.actions : {}), {}, {
            setActive: function () {
              var _setActive3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5);
              }));
              function setActive() {
                return _setActive3.apply(this, arguments);
              }
              return setActive;
            }(),
            setDisabled: function () {
              var _setDisabled3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              function setDisabled() {
                return _setDisabled3.apply(this, arguments);
              }
              return setDisabled;
            }()
          })
        });
      }
    };
  });
  (0, _react.useEffect)(function () {
    if (active !== _active) {
      _setActive(active);
    }
  }, [active]);
  (0, _react.useEffect)(function () {
    if (disabled !== _disabled) {
      _setDisabled(disabled);
    }
  }, [disabled]);
  var buttonRef = (0, _react.useRef)();
  var tipModal = (0, _react.useRef)();
  var tipComponent = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement(_Paper["default"], Object.assign({}, rest.target === '_blank' && Component === 'a' ? {
    noopener: '',
    noreferrer: ''
  } : {}, ariaLabel ? {
    'aria-label': ariaLabel
  } : {}, rest, {
    Component: Component,
    defaultClassName: (0, _clsx15["default"])(classNames.button, classNames['button-' + size], classNames['button-' + variant], (0, _defineProperty2["default"])({}, classNames.buttonDisabled, _disabled), (0, _defineProperty2["default"])({}, classNames.buttonActive, _active), (0, _defineProperty2["default"])({}, classNames.buttonDisableElevation, disableElevation), (0, _defineProperty2["default"])({}, classNames.buttonOnlyIcon, _onlyIcon), (0, _defineProperty2["default"])({}, classNames.buttonFullWidth, fullWidth), (0, _defineProperty2["default"])({}, classNames.buttonCircle, circle), (0, _defineProperty2["default"])({}, classNames.buttonStartIconSeparator, startIcon && startIconSeparator), (0, _defineProperty2["default"])({}, classNames.buttonEndIconSeparator, endIcon && endIconSeparator), (0, _defineProperty2["default"])({}, classNames.buttonEnablePaperSizes, enablePaperSizes), (0, _defineProperty2["default"])({}, classNames.buttonStopPropagation, stopPropagation), classes.container, defaultClassName),
    className: className
  }, href ? {
    href: href
  } : {}, {
    onClick: onClickResolver,
    onTouchStart: function onTouchStart() {
      tipModal.isTouch = true;
    },
    onMouseEnter: function () {
      var _onMouseEnter = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7() {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!tipModal.isTouch) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return");
            case 2:
              if (!tipModal.actions) {
                _context7.next = 5;
                break;
              }
              _context7.next = 5;
              return tipModal.actions.setOpen(true);
            case 5:
              if (!rest.onMouseEnter) {
                _context7.next = 8;
                break;
              }
              _context7.next = 8;
              return rest.onMouseEnter();
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function onMouseEnter() {
        return _onMouseEnter.apply(this, arguments);
      }
      return onMouseEnter;
    }(),
    onMouseLeave: function () {
      var _onMouseLeave = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8() {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!tipModal.isTouch) {
                _context8.next = 3;
                break;
              }
              tipModal.isTouch = false;
              return _context8.abrupt("return");
            case 3:
              if (!tipModal.actions) {
                _context8.next = 6;
                break;
              }
              _context8.next = 6;
              return tipModal.actions.setOpen(false);
            case 6:
              if (!rest.onMouseLeave) {
                _context8.next = 9;
                break;
              }
              _context8.next = 9;
              return rest.onMouseLeave();
            case 9:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function onMouseLeave() {
        return _onMouseLeave.apply(this, arguments);
      }
      return onMouseLeave;
    }()
  }, _disabled ? {
    disabled: _disabled
  } : {}, _active ? {
    active: ''
  } : {}, {
    variant: paperVariant ? paperVariant : variant === 'inline' ? 'inherit' : variant,
    elevation: null,
    effect: function effect(_ref8) {
      var actions = _ref8.actions;
      container.actions = actions;
      if (tip) {
        var _tipComponent$actions;
        (_tipComponent$actions = tipComponent.actions) === null || _tipComponent$actions === void 0 ? void 0 : _tipComponent$actions.setAnchorEl(buttonRef.current);
      }
    },
    ref: function ref(e) {
      buttonRef.current = e;
      if (tip) {
        var _tipComponent$actions2;
        (_tipComponent$actions2 = tipComponent.actions) === null || _tipComponent$actions2 === void 0 ? void 0 : _tipComponent$actions2.setAnchorEl(buttonRef.current);
      }
      if (_ref10) {
        if (typeof _ref10 === 'function') {
          _ref10(e);
        } else if (_ref10 && typeof _ref10 === 'object') {
          _ref10.current = e;
        }
      }
    }
  }, stopPropagation ? {
    'stop-propagation': ''
  } : {}, {
    draggable: draggable
  }), ButtonBaseContentComponent ? /*#__PURE__*/_react["default"].createElement(ButtonBaseContentComponent, null) : /*#__PURE__*/_react["default"].createElement(TypographyComponent, Object.assign({
    variant: variant === 'inline' ? 'button-' + variant : 'button-' + size,
    disabled: _disabled
  }, TypographyProps, {
    className: (0, _clsx15["default"])(classNames.buttonContentContainer, classes.content, TypographyProps.className)
  }), !_onlyIcon && startIcon ? /*#__PURE__*/_react["default"].createElement(StartIconContainerComponent, Object.assign({}, !disableForceUpdateForIcons ? {
    key: 'startIcon' + _active
  } : {}, {
    active: _active,
    disabled: _disabled,
    size: size,
    color: rest.color,
    variant: variant,
    className: (0, _clsx15["default"])(classNames.buttonStartIcon, classes.startIcon)
  }), startIcon) : null, _onlyIcon ? /*#__PURE__*/_react["default"].createElement(IconContainerComponent, Object.assign({}, !disableForceUpdateForIcons ? {
    key: 'icon' + _active
  } : {}, {
    active: _active,
    disabled: _disabled,
    size: size,
    color: rest.color,
    variant: variant,
    className: (0, _clsx15["default"])(classNames.buttonOnlyIconSvg, classes.icon)
  }), icon || startIcon) : /*#__PURE__*/_react["default"].createElement(LabelComponent, {
    className: (0, _clsx15["default"])(classNames.buttonLabel, (0, _defineProperty2["default"])({}, classNames.buttonLabelEnableWrap, labelEnableWrap), (0, _defineProperty2["default"])({}, classNames.buttonLabelWidthSecondaryText, secondaryText), (0, _defineProperty2["default"])({}, classNames.buttonSecondaryTextEnableWrap, secondaryTextEnableWrap), classes.label, (0, _defineProperty2["default"])({}, classes.labelWidthSecondaryText, secondaryText && classes.labelWidthSecondaryText))
  }, secondaryText ? /*#__PURE__*/_react["default"].createElement("span", null, children || label, /*#__PURE__*/_react["default"].createElement("span", null, secondaryText)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children || label)), !_onlyIcon && endIcon ? /*#__PURE__*/_react["default"].createElement(EndIconContainerComponent, Object.assign({}, !disableForceUpdateForIcons ? {
    key: 'endIcon' + _active
  } : {}, {
    active: _active,
    disabled: _disabled,
    size: size,
    color: rest.color,
    variant: variant,
    className: (0, _clsx15["default"])(classNames.buttonEndIcon, classes.endIcon)
  }), endIcon) : null), tip ? /*#__PURE__*/_react["default"].createElement(Tip, {
    TipPopoverComponent: TipPopoverComponent,
    TipPopoverProps: TipPopoverProps,
    TipPaperComponent: TipPaperComponent,
    TipPaperProps: TipPaperProps,
    tip: tip,
    tipModal: tipModal,
    buttonContext: buttonContext,
    anchorEl: buttonRef.current,
    effect: function effect(_ref9) {
      var actions = _ref9.actions;
      tipComponent.actions = actions;
    },
    classNames: classNames
  }) : null);
});